<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="filterPanelOpen"
  [cdkConnectedOverlayPanelClass]="'files-extension-filters-overlay-menu'"
  [cdkConnectedOverlayPositions]="[OverlayPositions.BOTTOM_RIGHT]"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="filterPanelOpen = false"
>
  <app-generic-filters-view
    [showFilterIcon]="false"
    [showCloseButton]="false"
    [showLastDivider]="false"
  ></app-generic-filters-view>
</ng-template>

<div class="container-fluid files-container" tabindex="1">
  <div
    class="file-nav top-section border-bottom d-flex align-items-center justify-content-between w-100"
    style="height: auto"
  >
    <div class="d-flex justify-content-start search-bar-div">
      <app-search-bar
        [searchTitle]="'Search Files' | translate"
        [editSearchValue]="filtersService.searchValue"
        (filter)="setSearchValue($event)"
      >
      </app-search-bar>
      <span
        *ngIf="
          showResultsNumber && activeFolder && (filesLoading$ | async) === false && isFiltersApplied
        "
        class="searchResult"
      >
        {{ displayedResultsCount === 0 ? ('No' | translate) : displayedResultsCount }}
        {{ 'results found' | translate }}
      </span>
    </div>
    <div class="d-flex justify-content-end align-items-center ms-auto">
      <button
        mat-icon-button
        (click)="filterPanelOpen = !filterPanelOpen"
        type="button"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        class="pencil-filters-button pcl-files-tune-filter pcl-files-extension-tune-filter"
        data-name="upload-tool-selection-pencil-files-filter"
      >
        <mat-icon> tune </mat-icon>
        <ng-container *ngIf="(filtersService.appliedFilters$ | async)?.length as filterCount">
          <span class="filters-badge">{{ filterCount }}</span>
        </ng-container>
      </button>
      <button
        mat-icon-button
        (click)="gridView = !gridView"
        class="pcl-files-ext-list-alt"
        type="button"
        data-name="upload-tool-selection-pencil-files-grid-list"
      >
        <mat-icon *ngIf="!gridView">view_module</mat-icon>
        <mat-icon *ngIf="gridView">list_alt</mat-icon>
      </button>
    </div>
  </div>
  <div
    *ngIf="activeFolder && path?.length > 0 && !activeFolderIsRoot"
    class="cmt-8 cmb-8 folder-breadcrumb d-flex flex-row flex-wrap"
  >
    <div *ngFor="let p of path; let i = index" class="d-flex flex-row">
      <div class="folder" (click)="backInPath(i)">
        {{
          p.name === institutionId ? ('Files' | translate) : (p.name | truncate: [maxNameLength])
        }}
      </div>
      <i class="material-icons">chevron_right</i>
    </div>
    <div class="active">
      {{
        activeFolder.name === institutionId
          ? ('Files' | translate)
          : (activeFolder.name | truncate: [maxNameLength])
      }}
    </div>
  </div>
  <app-applied-filter-pills
    *ngIf="(filtersService.appliedFilters$ | async)?.length"
    class="filter-border"
  ></app-applied-filter-pills>
  <div
    class="files-extension-results"
    [class.files-extension-results-spaced]="!path?.length || isFiltersApplied"
  >
    <div
      *ngIf="
        currentFolders.length === 0 &&
        currentFiles.length === 0 &&
        (filesLoading$ | async) === false
      "
      class="files-extension-empty-state"
    >
      <ng-container *ngIf="isFiltersApplied">
        {{ 'No matching items found' | translate }}
      </ng-container>
      <ng-container *ngIf="!isFiltersApplied">
        {{ 'No items found' | translate }}
      </ng-container>
    </div>
    <app-extended-grid-view
      *ngIf="gridView"
      #filesList
      [activeFolder]="activeFolder"
      [draggingWithoutSelect]="true"
      [enforcingFilter]="enforcingFilter"
      [isCreatingFolder]="false"
      [canSelect]="true"
      [maxNameLength]="maxNameLength"
      [user]="user"
      [loading]="(filesLoading$ | async) && !scrolling"
      [hideFolders]="hideFoldersForCurrentView"
      (toggledAll)="fetchFile.emit(this.selectedFiles)"
      (toggleSelectionEmitter)="handleToggleSelection($event)"
      (openFolder)="openFolder($event.folder, $event.append)"
      (scroll)="onScrollDown()"
      (snackbar)="showSnackbar($event)"
    >
    </app-extended-grid-view>
    <app-extended-list-view
      *ngIf="!gridView"
      #filesList
      [activeFolder]="activeFolder"
      [draggingWithoutSelect]="true"
      [enforcingFilter]="enforcingFilter"
      [isCreatingFolder]="false"
      [canSelect]="true"
      [maxNameLength]="maxNameLength"
      [user]="user"
      [loading]="(filesLoading$ | async) && !scrolling"
      [hideFolders]="hideFoldersForCurrentView"
      (toggledAll)="fetchFile.emit(this.selectedFiles)"
      (toggleSelectionEmitter)="handleToggleSelection()"
      (openFolder)="openFolder($event.folder, $event.append)"
      (scroll)="onScrollDown()"
      (snackbar)="showSnackbar($event)"
    >
    </app-extended-list-view>

    <app-content-loader
      *ngIf="filesLoading$ | async"
      [blockCount]="25"
      [file]="true"
      [singleLineList]="false"
      [border]="false"
      [list]="false"
    >
    </app-content-loader>
  </div>
</div>
